import * as React from "react";

const UserIcon: React.FC = () => {
  return (
    <svg
      width="27px"
      height="32px"
      viewBox="0 0 27 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.686 0C9.552 0 6.181 3.348 6.181 7.452c0 4.105 3.37 7.452 7.505 7.452 4.134 0 7.505-3.347 7.505-7.452 0-4.104-3.37-7.452-7.505-7.452zm0 1.753c3.18 0 5.74 2.542 5.74 5.7 0 3.157-2.56 5.698-5.74 5.698s-5.74-2.541-5.74-5.699c0-3.157 2.56-5.699 5.74-5.699zM.441 29.781v.027c-.005.317.004.648.014.905a.88.88 0 00.883.849h3.077a.891.891 0 00.633-.254.874.874 0 00-.633-1.5H2.207c0-6.263 4.963-11.397 11.037-11.397h.883c6.074 0 11.037 5.134 11.037 11.397H7.947a.89.89 0 00-.633.252.871.871 0 000 1.248.891.891 0 00.633.254h18.087a.88.88 0 00.881-.836c.017-.337.014-.606.014-.918 0-.746-.074-1.476-.193-2.191-.47-3.393-2.052-6.11-4.747-8.151-2.17-1.75-4.894-2.808-7.863-2.808h-.883C6.179 16.658.457 22.606.44 29.78z"
        transform="translate(-606 -362) translate(407 347) translate(148) translate(51 15)"
        fill="#09C"
        fillRule="nonzero"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
};
export default React.memo(UserIcon);
